define('recruit-modal/recruit-done-modal',['require','plugins/dialog'],function (require) {
    var dialog = require('plugins/dialog');

    var RecruitDoneModal = function () {
        var self = this;

        self.close = function () {
            dialog.close(self);
        };
    };

    RecruitDoneModal.show = function () {
        dialog.show(new RecruitDoneModal(), {}, 'recruit');
    };

    return RecruitDoneModal;
});

